<template>
  <div class="ops-page">
    <div class="table-head">
      <span class="table-title">CoWall置顶</span>
      <Button type="primary" disabled>置顶</Button>
    </div>
    <Alert type="warning" show-icon>
      接口待补充，暂不可用。管理端置顶接口就绪后再开放操作。
    </Alert>
    <Table :columns="columns" :data="[]" />
  </div>
</template>

<script>
export default {
  name: 'OpsCoWallTop',
  data() {
    return {
      columns: [
        { title: '序号', key: 'index', width: 70 },
        { title: '砖 ID', key: 'brick_id', minWidth: 120 },
        { title: '用户 ID', key: 'user_id', minWidth: 120 },
        { title: '状态', key: 'status', width: 100 },
        { title: '操作', key: 'action', width: 120 },
      ],
    }
  },
}
</script>

<style scoped>
.ops-page {
  padding: 16px;
}

.table-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.table-title {
  font-weight: bold;
  font-size: 16px;
}
</style>
